import { render, staticRenderFns } from "./AsignacionFunciones.vue?vue&type=template&id=62a99707"
import script from "./AsignacionFunciones.vue?vue&type=script&lang=js"
export * from "./AsignacionFunciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports